// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1rnqS","productName":"Table_productName__2k71r"};